import { client } from './axios';

const login = (body: LoginBody): Promise<LoginResponse> =>
  client.post(`/crypto-account-apis/authentication/email-login`, body);

const authService = {
  login,
};
export default authService;
